"use strict";

exports.__esModule = true;
exports["default"] = More;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function More(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.27 4.732A15.828 15.828 0 0 0 16 .063c-4.257 0-8.26 1.657-11.27 4.669A15.828 15.828 0 0 0 .063 16c0 4.257 1.658 8.26 4.668 11.27A15.83 15.83 0 0 0 16 31.938c4.257 0 8.26-1.658 11.27-4.668A15.835 15.835 0 0 0 31.938 16c0-4.257-1.658-8.259-4.668-11.268zM6.76 19.415a3.414 3.414 0 1 1-.001-6.829 3.414 3.414 0 0 1 .001 6.829zm9.24 0a3.414 3.414 0 1 1-.001-6.829A3.414 3.414 0 0 1 16 19.415zm9.24 0a3.414 3.414 0 1 1-.001-6.829 3.414 3.414 0 0 1 .001 6.829z"
  }));
}